import { Actions, ActionTypes, ICalendarPersistence } from './actions';

const defaultCalendarState = {} as ICalendarState;
const defaultAction = { type: '_' } as any;

export const persistence = (state = defaultCalendarState, action: Actions = defaultAction) => {
	switch (action.type) {
		case ActionTypes.UPDATE_PERSISTENCE:
			return { ...state, persistence: action.payload };
		default:
			return state;
	}
};

export interface ICalendarState {
	persistence: ICalendarPersistence;
}

export default persistence;
